import { HatElement } from '@/components/hat-element.js';

class HatLayoutHome extends HatElement {
  constructor() {
    super();

    this.root.innerHTML = `
      <style>
        :host {
          display: block;
          min-height: 100vh;
          width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          position: relative;
        }

        :host::before {
          content: "";
          position: fixed;
          inset: 0;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          z-index: -1;
        }

        .wrapper {
          min-height: 100vh;
          display: flex;
          justify-content: center;
        }

        .container {
          max-width: 1200px;
          width: 100%;
        }

        .header {
          text-align: center;
          color: white;
          margin-bottom: 60px;
        }

        .header h1 {
          font-size: 3rem;
          margin-bottom: 10px;
          font-weight: 700;
        }

        .subtitle {
          font-size: 1.2rem;
          opacity: 0.9;
        }

        .footer {
          text-align: center;
          color: white;
          opacity: 0.8;
          font-size: 0.9rem;
        }

        @media (max-width: 768px) {
          .header h1 {
            font-size: 2rem;
          }

          .subtitle {
            font-size: 1rem;
          }

          .features {
            grid-template-columns: 1fr;
            gap: 20px;
          }
        }
      </style>

      <div class="wrapper">
        <div class="container">
          <header class="header">
            <h1>Home Asset Tracker</h1>
            <p class="subtitle">Track and manage your home appliances</p>
          </header>

          <main>
            <slot></slot>
          </main>


          <footer class="footer">
            <p>&copy; 2026 Home Asset Tracker. All rights reserved.</p>
          </footer>
        </div>
      </div>
    `;
  }
}

customElements.define("hat-layout-home", HatLayoutHome);